<template>
  <div>
    <div
      class="kp-modal-default kp-modal-medium"
      tabindex="-1"
      role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">

          <div class="modal-header">
            <button class="close" @click="$emit('close')">
              <i class="fa fa-times"></i>
            </button>
            <slot name="header"></slot>
          </div>

          <div class="modal-body">
            <slot name="body"></slot>
          </div>

          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
    };
  },
  computed: mapGetters({
    topBarConfig: 'topBar/config',
  }),
};
</script>



// WEBPACK FOOTER //
// GeneralLayout.vue?545977f0